module.exports = __webpack_public_path__ + "img/icone-paginas.6d8f283d.svg";